import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54d84a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "type-select" }, "Musisz doprecyzować swój wybór", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Wybierz typ...", -1))
const _hoisted_6 = {
  key: 0,
  value: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "p-1 form-group d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "has-no-vin mt-2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVinSelect && _ctx.toggleVinSelect(...args)))
    }, "Nie znam VINu"),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        placeholder: "Wpisz VIN...",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vin) = $event)),
        class: "form-control vin-input",
        name: "vin",
        disabled: _ctx.types.length
      }, null, 8, _hoisted_2), [
        [_vModelText, _ctx.vin]
      ])
    ]),
    (_ctx.types.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", {
            class: "vin-fix",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.correctVin && _ctx.correctVin(...args)))
          }, "Edytuj VIN"),
          _hoisted_4,
          (_ctx.types)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: "form-select form-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedType) = $event))
              }, [
                _hoisted_5,
                (_ctx.loadingTypes)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_6, "Ładuję..."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carsByVin, (car) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: car.type.typeId,
                    value: car.type.typeId
                  }, _toDisplayString(_ctx.typeOptionName(car)), 9, _hoisted_7))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.selectedType]
              ])
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.checkingVin)
        ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn button-gradient btn-width",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectVin && _ctx.selectVin(...args)))
          }, " Wybierz "))
    ])
  ]))
}